"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonFormatter = require("./service/jsonFormatter");
var DocumentFormattingEditProvider = /** @class */ (function () {
    function DocumentFormattingEditProvider() {
    }
    DocumentFormattingEditProvider.prototype.provideDocumentFormattingEdits = function (model, options, token) {
        return Promise.resolve(jsonFormatter.format(model, model.getFullModelRange(), options));
    };
    return DocumentFormattingEditProvider;
}());
exports.DocumentFormattingEditProvider = DocumentFormattingEditProvider;
var DocumentRangeFormattingEditProvider = /** @class */ (function () {
    function DocumentRangeFormattingEditProvider() {
    }
    DocumentRangeFormattingEditProvider.prototype.provideDocumentRangeFormattingEdits = function (model, range, options, token) {
        return Promise.resolve(jsonFormatter.format(model, range, options));
    };
    return DocumentRangeFormattingEditProvider;
}());
exports.DocumentRangeFormattingEditProvider = DocumentRangeFormattingEditProvider;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/monaco/languages/json/formatting.js
 ** module id = 428
 ** module chunks = 0
 **/